// Custom Message Email Generator for HomeGo Removals
// Allows sending personalized messages to customers

const generateCustomMessageEmailHTML = (data) => {
  const {
    customer_name = "Valued Customer",
    subject_line = "Message from HomeGo Removals",
    message_content = "",
    include_contact_footer = true,
    consultant_name = "Thomas Jacobs",
    consultant_title = "Customer Consultant",
    consultant_phone = "0330 043 4791",
    consultant_email = "info@homego-removals.com"
  } = data;

  // Process message content - convert line breaks to <br> tags
  const formattedMessage = message_content
    .replace(/\n\n/g, '</p><p style="margin: 0 0 15px 0; font-size: 15px; line-height: 1.6; color: #333;">')
    .replace(/\n/g, '<br>');

  return `
<!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>${subject_line}</title>
</head>
<body style="margin: 0; padding: 0; font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif; background-color: #f5f5f5;">
  <table border="0" cellpadding="0" cellspacing="0" width="100%" style="background-color: #f5f5f5;">
    <tr>
      <td align="center" style="padding: 20px 10px;">
        <table border="0" cellpadding="0" cellspacing="0" width="100%" style="max-width: 600px; background-color: #ffffff; border-radius: 12px; overflow: hidden; box-shadow: 0 4px 20px rgba(0,0,0,0.1);">
          
          <!-- Header -->
          <tr>
            <td style="background: linear-gradient(135deg, #000000 0%, #1a1a1a 100%); padding: 25px 30px; text-align: center;">
              <table border="0" cellpadding="0" cellspacing="0" width="100%">
                <tr>
                  <td align="center">
                    <h1 style="margin: 0; font-size: 28px; font-weight: 800; letter-spacing: -1px;">
                      <span style="color: #D4AF37;">Home</span><span style="color: #ffffff;">Go</span>
                    </h1>
                    <p style="margin: 5px 0 0; font-size: 11px; color: #888; text-transform: uppercase; letter-spacing: 2px;">
                      Removals & Packing Ltd
                    </p>
                  </td>
                </tr>
              </table>
            </td>
          </tr>

          <!-- Gold Accent Bar -->
          <tr>
            <td style="background: linear-gradient(90deg, #D4AF37 0%, #F4D03F 50%, #D4AF37 100%); height: 4px;"></td>
          </tr>

          <!-- Greeting -->
          <tr>
            <td style="padding: 30px 30px 20px;">
              <p style="margin: 0; font-size: 18px; color: #000; font-weight: 600;">
                Dear ${customer_name},
              </p>
            </td>
          </tr>

          <!-- Message Content -->
          <tr>
            <td style="padding: 0 30px 30px;">
              <p style="margin: 0 0 15px 0; font-size: 15px; line-height: 1.6; color: #333;">
                ${formattedMessage}
              </p>
            </td>
          </tr>

          ${include_contact_footer ? `
          <!-- Contact Section -->
          <tr>
            <td style="padding: 0 30px 25px;">
              <table border="0" cellpadding="0" cellspacing="0" width="100%" style="background: #f8f8f8; border-radius: 12px; border: 1px solid #eee;">
                <tr>
                  <td style="padding: 20px;">
                    <p style="margin: 0 0 15px 0; font-size: 14px; color: #666;">
                      If you have any questions, please don't hesitate to reach out:
                    </p>
                    <table border="0" cellpadding="0" cellspacing="0" width="100%">
                      <tr>
                        <td width="50%" style="padding: 5px 0;">
                          <a href="tel:${consultant_phone.replace(/\s/g, '')}" style="display: inline-block; background: #000; color: #D4AF37; text-decoration: none; padding: 10px 20px; border-radius: 25px; font-size: 13px; font-weight: 600;">
                            📞 Call Us
                          </a>
                        </td>
                        <td width="50%" style="padding: 5px 0;">
                          <a href="mailto:${consultant_email}" style="display: inline-block; background: #D4AF37; color: #000; text-decoration: none; padding: 10px 20px; border-radius: 25px; font-size: 13px; font-weight: 600;">
                            ✉️ Email Us
                          </a>
                        </td>
                      </tr>
                    </table>
                  </td>
                </tr>
              </table>
            </td>
          </tr>
          ` : ''}

          <!-- Signature -->
          <tr>
            <td style="padding: 0 30px 25px;">
              <table border="0" cellpadding="0" cellspacing="0" width="100%">
                <tr>
                  <td>
                    <p style="margin: 0 0 5px 0; font-size: 14px; color: #333;">
                      Kind regards,
                    </p>
                    <p style="margin: 0 0 3px 0; font-size: 16px; font-weight: 700; color: #000;">
                      ${consultant_name}
                    </p>
                    <p style="margin: 0; font-size: 12px; color: #666;">
                      ${consultant_title} | HomeGo Removals
                    </p>
                  </td>
                </tr>
              </table>
            </td>
          </tr>



          <!-- Footer -->
          <tr>
            <td style="background: #000; padding: 25px 30px;">
              <table border="0" cellpadding="0" cellspacing="0" width="100%">
                <tr>
                  <td align="center">
                    <p style="margin: 0 0 10px 0; font-size: 11px; color: #888;">
                      HomeGo Removals & Packing Ltd
                    </p>
                    <p style="margin: 0 0 10px 0; font-size: 11px; color: #666;">
                      📞 0330 043 4791 | 📱 WhatsApp: 07440 414548
                    </p>
                    <p style="margin: 0; font-size: 10px; color: #555;">
                      Company Reg: 15302576 | www.homego-removals.com
                    </p>
                  </td>
                </tr>
              </table>
            </td>
          </tr>

        </table>
      </td>
    </tr>
  </table>
</body>
</html>
  `.trim();
};

// Pre-defined message templates
export const MESSAGE_TEMPLATES = [
  {
    id: 'items_list',
    name: '📦 Request Items List',
    subject: 'Items List Request - HomeGo Removals',
    content: `Thank you for your enquiry about our removals services.

To provide you with an accurate quote, could you please send us a list of items you're planning to move? This helps us determine the right van size and crew needed for your move.

You can simply reply to this email with:
• Large furniture items (sofas, beds, wardrobes, etc.)
• Number of boxes (estimated)
• Any special items (pianos, antiques, gym equipment, etc.)
• Access details at both properties (stairs, lifts, parking)

Once we have this information, we'll get back to you with a detailed quote within 24 hours.`
  },
  {
    id: 'facebook_thanks',
    name: '👍 Facebook Enquiry Thanks',
    subject: 'Thanks for Your Facebook Enquiry - HomeGo Removals',
    content: `Thank you so much for reaching out to us through our Facebook page!

We really appreciate you taking the time to contact HomeGo Removals. We've received your enquiry and a member of our team will be in touch shortly.

In the meantime, feel free to:
• Call us directly on 0330 043 4791
• WhatsApp us on 07440 414548
• Check out our 5-star reviews on Trustpilot

We look forward to helping you with your move!`
  },
  {
    id: 'quote_followup',
    name: '📋 Quote Follow-up',
    subject: 'Following Up on Your Quote - HomeGo Removals',
    content: `I hope this email finds you well.

I wanted to follow up on the quote we sent you recently. Have you had a chance to review it?

If you have any questions about the packages, pricing, or our services, please don't hesitate to ask. We're here to help make your move as smooth as possible.

If you're ready to proceed, simply reply to this email or give us a call, and we can secure your booking date.

Looking forward to hearing from you!`
  },
  {
    id: 'availability_check',
    name: '📅 Check Availability',
    subject: 'Checking In - HomeGo Removals',
    content: `I hope you're doing well!

I wanted to reach out to see if you've decided on a moving date yet. We're currently taking bookings and wanted to make sure we can accommodate your preferred date.

Our calendar fills up quickly, especially for weekends, so if you have a date in mind, let us know and we'll check availability for you.

Just reply with your preferred date and we'll get back to you right away!`
  },
  {
    id: 'thank_you_booking',
    name: '🎉 Thank You for Booking',
    subject: 'Thank You for Choosing HomeGo! 🏠',
    content: `Wonderful news - your booking is confirmed!

Thank you so much for choosing HomeGo Removals for your upcoming move. We're genuinely excited to help you settle into your new home.

Here's what happens next:
• You'll receive a confirmation email with all the details
• Our team will call you 24-48 hours before your move
• On the day, our crew will arrive on time and ready to work

If you need to make any changes or have questions before your move, just get in touch. We're always here to help.

See you on moving day!`
  },
  {
    id: 'custom',
    name: '✏️ Write Custom Message',
    subject: 'Message from HomeGo Removals',
    content: ''
  }
];

export default generateCustomMessageEmailHTML;
